export enum FieldTypeEnum {
  BRIEFD_CLIENT_COUNTRY = 'briefd.client.country',
  BRIEFD_CLIENT_CITY = 'briefd.client.city',
  BRIEFD_VEHICLE_PHOTOGRAPHS = 'briefd.vehicle.photographs',
  BRIEFD_VEHICLE_SOURCING_CONTACT = 'briefd.vehicle.sourcing_contact',
  BRIEFD_VEHICLE_PURCHASE_PHOTOGRAPHS = 'briefd.vehicle.purchase_photographs',
  BRIEFD_VEHICLE_EXTERNAL_IMAGE_BACKGROUND_REMOVAL = 'briefd.vehicle.external_image_background_removal',
  BRIEFD_VEHICLE_PRICING_DISCOUNT_TYPE = 'briefd.vehicle.pricing_discount_type',
  BRIEFD_VEHICLE_PRICING_DISCOUNTED_PRICE = 'briefd.vehicle.pricing_discounted_price',
  BRIEFD_VEHICLE_WEIGHT = 'briefd.vehicle.weight',
}
